import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Select from "react-select";
import Alert from "@material-ui/lab/Alert";
import LinearProgress from "@material-ui/core/LinearProgress";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  checkbox: {
    width: "20px",
    height: "20px",
  },
  alert: {
    marginBottom: "50px",
  },
});

const NewSite = () => {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    unusedSites: [],
    dialPlans: [],
    voicePolicies: [],
    primarySites: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Forms/SiteFormData")
      .then((response) => response.json())
      .then((data) =>
        setFormData({
          unusedSites: data.unusedSites,
          dialPlans: data.dialPlans,
          voicePolicies: data.voicePolicies,
          primarySites: data.primarySites,
          loading: false,
        })
      );
  }, []);
  return (
    <>
      {formData.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <SiteForm data={formData} />
      )}
    </>
  );
};

const SiteForm = (props) => {
  const { data } = props;
  const classes = useStyles();
  const [siteType, setSiteType] = useState("");
  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const typeSelectionHandler = (value) => {
    setSiteType(value);
  };

  const siteOptions = [
    { value: "primary", label: "Primary" },
    { value: "secondary", label: "Secondary" },
  ];

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <CardContent>
              <div class="mb-3 row">
                <div class="col-sm-12">
                  <Select
                    placeholder="Select Site Type"
                    options={siteOptions}
                    onChange={(e) => typeSelectionHandler(e.value)}
                    menuPortalTarget={document.querySelector("body")}
                  />
                </div>
              </div>
              {siteType === "primary" && (
                <PrimarySite
                  sites={data.unusedSites}
                  dialPlans={data.dialPlans}
                  voicePolicies={data.voicePolicies}
                  clearAlert={clearAlert}
                  sendAlert={sendAlert}
                />
              )}
              {siteType === "secondary" && (
                <>
                  <SecondarySite
                    sites={data.unusedSites}
                    primarySites={data.primarySites}
                    clearAlert={clearAlert}
                    sendAlert={sendAlert}
                  />
                </>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

const PrimarySite = (props) => {
  const { voicePolicies, dialPlans, sites, clearAlert, sendAlert } = props;
  const classes = useStyles();

  let pSite = useRef(null);
  let dialP = useRef(null);
  let voiceP = useRef(null);
  let sSite = useRef(null);

  const [primarySite, setPrimarySite] = useState("");
  const [primaryDNS, setPrimaryDNS] = useState("");
  const [dialPlan, setDialPlan] = useState("");
  const [voicePolicy, setVoicePolicy] = useState("");
  const [secondarySite, setSecondarySite] = useState(null);
  const [secondaryDNS, setSecondaryDNS] = useState("");

  const [addSecondary, setAddSecondary] = useState(false);
  const [unusedSites, setUnusedSites] = useState(sites);

  const [loading, setLoading] = useState(false);
  const [successFetch, setSuccessFetch] = useState(false);

  const getUnusedSites = () => {
    return unusedSites.map((site) => ({
      value: site.siteId,
      label: `${site.siteId} - ${site.siteName}`,
    }));
  };

  const getDialPlans = () => {
    return dialPlans.map((plan) => ({
      value: plan.value,
      label: plan.value,
    }));
  };
  console.log("addSecondary: ", addSecondary);

  const getVoicePolicies = () => {
    return voicePolicies.map((policy) => ({
      value: policy.value,
      label: policy.value,
    }));
  };

  const getUnusedSecondarySites = () => {
    return unusedSites
      .filter((sSite) => sSite.siteId !== primarySite.siteId)
      .map((sSite) => ({
        value: sSite.siteId,
        label: `${sSite.siteId} - ${sSite.siteName}`,
      }));
  };

  const poolSubmitHandler = async (e) => {
    e.preventDefault();
    clearAlert();

    const formData = {
      id: primarySite?.siteId,
      name: primarySite?.siteName,
      city: primarySite?.propertyCity,
      country: primarySite?.propertyCountry,
      state: primarySite?.propertyStateProvince,
      dnsSiteCode: primaryDNS,
      dialPlan,
      voicePolicy,
      secondarySites: addSecondary
        ? [
            {
              id: secondarySite?.siteId,
              primarySiteId: primarySite?.siteId,
              name: secondarySite?.siteName,
              city: secondarySite?.propertyCity,
              country: secondarySite?.propertyCountry,
              state: secondarySite?.propertyStateProvince,
              dnsSiteCode: secondaryDNS,
            },
          ]
        : [],
    };

    // Validation
    const missing = [];
    if (!primarySite) missing.push("Site");
    if (!dialPlan) missing.push("Dial Plan");
    if (!voicePolicy) missing.push("Voice Policy");
    if (addSecondary && !secondarySite) missing.push("Secondary Site");

    if (missing.length) {
      sendAlert(`Validation Error - ${missing.join(", ")} Required`, "warning");
      return;
    }

    setLoading(true);

    try {
      const res = await fetchWithToken(`api/Sites/`, "POST", formData);
      const data = await res.json();

      if (res.ok) {
        setSuccessFetch(true);
        sendAlert(data.returnMessage || "Saved successfully!", "success");

        setUnusedSites((prev) =>
          addSecondary
            ? prev.filter(
                (site) =>
                  site.siteId !== formData.id &&
                  site.siteId !== formData.secondarySites[0].id
              )
            : prev.filter((site) => site.siteId !== formData.id)
        );
      } else {
        sendAlert(data.returnMessage || "Error saving data", "error");
      }
    } catch (err) {
      sendAlert("Error saving data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (successFetch) {
      clearAll();
      setAddSecondary(false); // Reset secondary site toggle
      setSuccessFetch(false); // Reset flag
    }
  }, [successFetch]);

  const addSecondaryHandler = (e) => {
    const isChecked = e.target.checked;
    setAddSecondary(isChecked);

    if (!isChecked) {
      setSecondarySite(null);
      setSecondaryDNS("");
    }
  };

  const clearAll = () => {
    setAddSecondary(false);
    setPrimarySite(null);
    setPrimaryDNS("");
    setDialPlan("");
    setVoicePolicy("");
    setSecondarySite(null);
    setSecondaryDNS("");
  };

  useEffect(() => {
    if (
      primarySite?.siteId === secondarySite?.siteId &&
      secondarySite?.siteId
    ) {
      setSecondarySite(null);
      sSite.select?.clearValue();
    }
  }, [primarySite]);

  return (
    <>
      <div className="mb-3 row">
        <div className="col-sm-12">
          <Select
            value={
              primarySite
                ? { value: primarySite.siteId, label: primarySite.siteName }
                : null
            }
            placeholder="Select Site *"
            options={getUnusedSites()}
            onChange={(selection) => {
              clearAlert();
              setPrimarySite(
                selection && selection.value
                  ? sites.find((site) => site.siteId === selection.value)
                  : ""
              );
            }}
            menuPortalTarget={document.querySelector("body")}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <div className="col-sm-12">
          <input
            type="text"
            style={{ fontSize: "0.875rem" }}
            className="form-control"
            name="dnsPrimary"
            placeholder="Enter DNS Site Code"
            maxLength="3"
            value={primaryDNS}
            onChange={(e) => {
              clearAlert();
              setPrimaryDNS(e.target.value.toUpperCase());
            }}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <div className="col-sm-12">
          <Select
            placeholder="Select Dial Plan *"
            value={dialPlan ? { value: dialPlan, label: dialPlan } : null}
            options={getDialPlans()}
            onChange={(selection) => {
              clearAlert();
              setDialPlan(selection?.value || "");
            }}
            menuPortalTarget={document.querySelector("body")}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <div className="col-sm-12">
          <Select
            placeholder="Select Voice Policy *"
            value={
              voicePolicy ? { value: voicePolicy, label: voicePolicy } : null
            }
            options={getVoicePolicies()}
            onChange={(selection) => {
              clearAlert();
              setVoicePolicy(selection?.value || "");
            }}
            menuPortalTarget={document.querySelector("body")}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <div className="col-sm-3" style={{ marginLeft: "10px" }}>
          <h6>Add Secondary Site:</h6>
        </div>
        <div className="col-sm-1">
          <div className="form-check">
            <input
              className={`form-check-input ${classes.checkbox}`}
              type="checkbox"
              // disabled={!primarySite}
              checked={addSecondary} // bind to state
              onChange={addSecondaryHandler} // use onChange, not onClick
            />
          </div>
        </div>
      </div>

      {addSecondary && (
        <>
          <div className="mb-3 row">
            <div className="col-sm-12">
              <Select
                placeholder="Select Secondary Site *"
                value={
                  secondarySite && secondarySite.siteId
                    ? {
                        value: secondarySite.siteId,
                        label: secondarySite.siteName,
                      }
                    : null
                }
                options={getUnusedSecondarySites()}
                onChange={(selection) => {
                  clearAlert();
                  setSecondarySite(
                    selection && selection.value
                      ? sites.find((site) => site.siteId === selection.value)
                      : null
                  );
                }}
                menuPortalTarget={document.querySelector("body")}
              />
            </div>
          </div>

          <div className="mb-3 row">
            <div className="col-sm-12">
              <input
                className="form-control"
                type="text"
                style={{ fontSize: "0.875rem" }}
                name="dnsSecondary"
                placeholder="Enter DNS Secondary Site Code"
                maxLength="3"
                value={secondaryDNS}
                onChange={(e) => {
                  clearAlert();
                  setSecondaryDNS(e.target.value.toUpperCase());
                }}
              />
            </div>
          </div>
        </>
      )}

      {loading && (
        <div style={{ margin: "25px" }}>
          <span style={{ display: "table", margin: "0 auto" }}>
            Please Wait For Process to Finish
          </span>
          <LinearProgress />
        </div>
      )}

      <Button
        variant="contained"
        className={classes.button}
        color="primary"
        onClick={poolSubmitHandler}
      >
        Submit
      </Button>
    </>
  );
};

const SecondarySite = (props) => {
  const { sites, primarySites, clearAlert, sendAlert } = props;
  const classes = useStyles();

  let sSite = useRef(null);
  let pSite = useRef(null);

  const [secondarySite, setSecondarySite] = useState(null);
  const [primarySite, setPrimarySite] = useState("");
  const [secondaryDNS, setSecondaryDNS] = useState("");
  const [unusedSites, setUnusedSites] = useState(sites);
  const [loading, setLoading] = useState(false);
  const [successFetch, setSuccessFetch] = useState(false);

  const getUnusedSites = () =>
    unusedSites.map((site) => ({
      value: site.siteId,
      label: `${site.siteId} - ${site.siteName}`,
    }));

  const getPrimarySites = () =>
    primarySites.map((site) => ({
      value: site.id,
      label: `${site.id} - ${site.name}`,
    }));

  const poolSubmitHandler = async (e) => {
    e.preventDefault();
    clearAlert();

    // Prepare form data
    const formData = {
      id: secondarySite?.siteId,
      primarySiteId: primarySite?.id,
      name: secondarySite?.siteName,
      city: secondarySite?.propertyCity,
      country: secondarySite?.propertyCountry,
      state: secondarySite?.propertyStateProvince,
      dnsSiteCode: secondaryDNS,
    };

    // ✅ Validation (only required fields)
    const missing = [];
    if (!primarySite) missing.push("Primary Site");
    if (!secondarySite) missing.push("Secondary Site");
    if (!secondaryDNS) missing.push("DNS Site Code");

    if (missing.length) {
      sendAlert(`Validation Error - ${missing.join(", ")} Required`, "warning");
      return;
    }

    setLoading(true);

    try {
      const res = await fetchWithToken(`api/SecondarySites/`, "POST", formData);
      const data = await res.json();

      console.log("Response:", res);
      console.log("Data:", data);

      if (res.ok) {
        sendAlert(data.returnMessage || "Saved successfully!", "success");

        setUnusedSites((prev) =>
          prev.filter((site) => site.siteId !== formData.id)
        );

        clearAll();
      } else {
        sendAlert(data.returnMessage || "Error saving data", "error");
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      sendAlert("Error saving data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (successFetch) {
      clearAll();
      setSuccessFetch(false);
    }
  }, [successFetch]);

  const clearAll = () => {
    setSecondarySite(null);
    setPrimarySite("");
    setSecondaryDNS("");

    if (sSite?.select) sSite.select.clearValue();
    if (pSite?.select) pSite.select.clearValue();
  };

  return (
    <>
      <div className="mb-3 row">
        <div className="col-sm-12">
          <Select
            ref={(ref) => {
              sSite = ref;
            }}
            placeholder="Select Site *"
            options={getUnusedSites()}
            value={
              secondarySite
                ? {
                    value: secondarySite.siteId,
                    label: `${secondarySite.siteId} - ${secondarySite.siteName}`,
                  }
                : null
            }
            onChange={(selection) => {
              clearAlert();
              setSecondarySite(
                selection && selection.value
                  ? sites.find((site) => site.siteId === selection.value)
                  : ""
              );
            }}
            menuPortalTarget={document.querySelector("body")}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <div className="col-sm-12">
          <Select
            ref={(ref) => {
              pSite = ref;
            }}
            placeholder="Select Primary Site *"
            options={getPrimarySites()}
            value={
              primarySite
                ? {
                    value: primarySite.id,
                    label: `${primarySite.id} - ${primarySite.name}`,
                  }
                : null
            }
            onChange={(selection) => {
              clearAlert();
              setPrimarySite(
                selection && selection.value
                  ? primarySites.find((site) => site.id === selection.value)
                  : ""
              );
            }}
            menuPortalTarget={document.querySelector("body")}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <div className="col-sm-12">
          <input
            type="text"
            style={{ fontSize: "0.875rem" }}
            className="form-control"
            name="dnsPrimary"
            placeholder="Enter DNS Site Code *"
            maxLength="3"
            value={secondaryDNS}
            onChange={(e) => {
              clearAlert();
              setSecondaryDNS(e.target.value.toUpperCase());
            }}
          />
        </div>
      </div>

      {loading && (
        <div style={{ margin: "25px" }}>
          <span style={{ display: "table", margin: "0 auto" }}>
            Please Wait For Process to Finish
          </span>
          <LinearProgress />
        </div>
      )}

      <Button
        variant="contained"
        className={classes.button}
        color="primary"
        onClick={poolSubmitHandler}
      >
        Submit
      </Button>
    </>
  );
};

export default NewSite;
